"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholder = Placeholder;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var PlaceholderProvider_1 = require("../PlaceholderProvider");
/**
 * Search in the PlaceholderContext using the specified name to render a PlaceholderComponent.
 * If PlaceholderComponent exist, the component is rendered with `parameters` prop, otherwise nothing is rendered.
 * @param placeholderInput - contains name of the placeholder and parameters (key/value) to pass to the PlaceholderComponent
 * @returns
 */
function Placeholder(_a) {
    var name = _a.name, parameters = _a.parameters;
    var ctx = (0, PlaceholderProvider_1.usePlaceholderContext)();
    // We do not add ctx in the dependency array because it is not memoized
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var Component = (0, react_1.useMemo)(function () { return ctx[name]; }, [name]);
    // search if placeholder's component exist with placeholder's name
    if (!Component) {
        // not exist, so we do not display anything
        return null;
    }
    // placeholder component found so we display the component with his `parameters`
    return react_1.default.createElement(Component, { parameters: parameters });
}
//# sourceMappingURL=Placeholder.js.map